import React, { Component } from 'react';
import styles from './auth.module.scss';
import classnames from 'classnames';
import SixDigitInput from './sixDigitInput.js';
import API, { VERIFICATION_VIA_EMAIL } from '../utils/API';
import Error from '../Error/error';
import PrimaryButton from '../Buttons/primaryButton';
import SecondaryButton from '../Buttons/secondaryButton';
import TickIcon from '../../img/icons/tick-icon.svg';
import Loader from '../Loader/index';
import { strings } from '../utils/translations';
import { Errors } from '../utils/errors';

export default class VerifyEmail extends Component
{
    code = null;
    codeGenerated = false;
    
    constructor(props)
    {
        super(props);
        
        this.state =
        {
            sendingEmail: false,
            sendingEmailError: false,
            emailSent: false,
            
            sendingCode: false,
            sendingCodeError: false,
            emailVerified: false,
            
            showDidntReceiveDialog: false,
            showChangeEmailDialog: false,
            newEmail: '',
            newEmailError: false,
            changingEmail: false
        }
    }
    componentDidMount()
    {
        if (this.props.userId != null)
            this.generateVerificationCode();
        else
            this.sendEmail();
    }
    
    render()
    {
        const sendingEmailView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={styles.progress}></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('verifyYourEmail') }</h3>
                <Loader />
            </>;
        
        const sendingEmailErrorView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={styles.progress}></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('verifyYourEmail') }</h3>
                <Error text={ strings('errorSendingVerificationEmail') } />
                <PrimaryButton
                    text={ strings('retry') }
                    onClick={() => (this.props.userId != null && !this.codeGenerated) ? this.generateVerificationCode() : this.sendEmail()}
                />
            </>;
            
        const sendingCodeErrorView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={styles.progress}></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('verifyYourEmail') }</h3>
                <Error text={ strings('errorSendingVerificationCode') } />
                <SecondaryButton
                    text={ strings('editCode') }
                    onClick={() => this.setState({ sendingCodeError: false })}
                />
                <PrimaryButton
                    text={ strings('retry') }
                    onClick={() => this.sendVerifyUserByCode(this.code)}
                />
            </>;
        
        const title = <h3 className={styles.authTitle}>{ strings('verifyYourEmail') }</h3>
        const subtitle = <div className={styles.verifyContainer}>
                            <p>{ strings('verifyEmailText1') + ' ' }
                                <strong>{ (this.props.user != null || this.props.email != null) ? ` ${this.getUserEmail()}` : null }</strong>
                            </p>
                            <br />
                            <p>{ strings('verifyEmailText2') }</p>
                        </div>
        
        const didntReceiveDialog =
            <div className={styles.alternativeBox}>
                <h3 className={ classnames([styles.authTitle, styles.secondary]) }>{ strings('didntReceiveCode') }</h3>
                <div className={styles.verifyContainer}>
                    <p>{ strings('weSentTheCodeToThisEmail') }</p>
                    <strong>{ this.getUserEmail() }</strong>
                </div>

                <SecondaryButton
                    text={ strings('resend') }
                    onClick={() =>
                    {
                        this.setState({ showDidntReceiveDialog: false }, () =>
                        {
                            this.sendEmail(() =>
                            {
                                return (
                                    this.setState({
                                        error: true,
                                        errorText: strings('codeResent')
                                    })
                                )
                            });
                        });
                    }}
                />
                <PrimaryButton
                    text={ strings('changeEmail') }
                    onClick={() => this.setState({ showChangeEmailDialog: true, showDidntReceiveDialog: false }) }
                />
            </div>;
        
        const changeEmailDialog =
            <div className={styles.alternativeBox}>
                <h3 className={ classnames([styles.authTitle, styles.secondary]) }>{ strings('didntReceiveCode') }</h3>
                <div className={styles.verifyContainer}>
                    <p>{ strings('writeNewEmailForYourAccount') }</p>
                    {
                        this.state.changingEmail ?
                        <Loader />
                        :
                        <input
                            label='Email'
                            placeholder={ strings('enterNewEmail') }
                            className="input"
                            value={this.state.newEmail}
                            onChange={e => this.setState({ newEmail: e.target.value })}
                        />
                    }
                </div>
                
                <div className={styles.box}>
                    {
                        this.state.newEmailError &&
                        <small>{ strings('emailHasWrongFormat') }</small>
                    }
                </div>
                
                <SecondaryButton
                    text={ strings('cancel') }
                    onClick={() =>
                    {
                        this.setState({ showChangeEmailDialog: false, showDidntReceiveDialog: true });
                    }}
                />
                <PrimaryButton
                    text={ strings('changeEmail') }
                    onClick={() =>
                    {
                        if (this.validateNewEmail())
                            this.changeEmail();
                    }}
                />
            </div>;
        
        const codeView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={styles.progress}></span>
                </div>
                    { title }
                    { subtitle }
                
                <div className={styles.box}>
                    <SixDigitInput
                        onCodeChanged={this.onCodeChanged.bind(this)}
                        onCodeFilled={this.onCodeFilled.bind(this)}
                    ></SixDigitInput>
                </div>
                
                {
                    (this.props.userId == null) &&
                    <div onClick={() => this.setState({ showDidntReceiveDialog: true })}>
                        <p className={styles.secondaryText}>
                            ¿No has recibido un email?
                            <a>HAZ CLICK AQUÍ</a>
                        </p>
                    </div>
                }
                
                { 
                    this.state.showDidntReceiveDialog &&
                    didntReceiveDialog
                }
                {
                    this.state.showChangeEmailDialog &&
                    changeEmailDialog
                }
                
            </>;
        
        const emailVerifiedView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={styles.progress}></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('emailVerified') }</h3>
                <div className={styles.verifyContainer}>
                    <div className={styles.verifyText}>
                        <img
                            className={styles.icon}
                            alt="Arrow icon"
                            src={TickIcon}
                        />
                        <p className={styles.primaryText}>{ strings('emailVerifiedSuccess') }</p>
                    </div>
                    <div className={ classnames([styles.verifyText, styles.unChecked]) }>
                        <img
                            className={styles.icon}
                            alt="Arrow icon"
                            src={TickIcon}
                        />
                        <p className={styles.primaryText}>{ strings('phoneVerifiedSuccess1') }</p>
                    </div>
                    <div className={ classnames([styles.verifyText, styles.unChecked]) }>
                        <img
                            className={styles.icon}
                            alt="Arrow icon"
                            src={TickIcon}
                        />
                        <p className={styles.primaryText}>{ strings('accountActive') }</p>
                    </div>
                </div>
            </>;
        
            
        let view = null;
        
        if (this.state.sendingEmail)
            view = sendingEmailView;
        else if (this.state.sendingEmailError)
            view = sendingEmailErrorView;
        else if (this.state.emailSent)
            view = codeView;
        
        if (this.state.sendingCode)
            view = sendingEmailView;
        else if (this.state.sendingCodeError)
            view = sendingCodeErrorView;
        else if (this.state.emailVerified)
            view = emailVerifiedView;
        
        return (
            <div>
                { view }
            </div>
        );
    }
    
    onCodeChanged(code)
    {
        this.code = code;
    }
    onCodeFilled()
    {
        this.sendVerifyUserByCode(this.code);
    }
    
    getUserId()
    {    
        return this.props.userId != null ? this.props.userId : this.props.user.id;
    }
    getUserEmail()
    {    
        return this.props.userId != null ? this.props.email : this.props.user.email;
    }
    
    generateVerificationCode()
    {
        this.codeGenerated = false;
        
        this.setState({ sendingEmail: true, sendingEmailError: false, emailSent: false }, () =>
        {
            API.getInstance().generateVerificationCode(this.getUserEmail())
            .then(response =>
            {
                this.codeGenerated = true;
                
                this.sendEmail();
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    sendingEmail: false,
                    sendingEmailError: true,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    sendEmail(onSuccessCb)
    {
        this.setState({ sendingEmail: true, sendingEmailError: false, emailSent: false }, () =>
        {
            API.getInstance().sendVerificationCode(this.getUserId(), VERIFICATION_VIA_EMAIL)
            .then(response =>
            {
                this.setState({ sendingEmail: false, emailSent: true });
                
                if (onSuccessCb != null)
                    onSuccessCb();
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    sendingEmail: false,
                    sendingEmailError: true,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    sendVerifyUserByCode(code)
    {
        this.setState({ sendingCode: true, sendingCodeError: false, emailVerified: false }, () =>
        {
            API.getInstance().verifyUserByCode(this.getUserId(), code, this.getUserEmail())
            .then(response =>
            {

                if (!response.data.status)
                {
                    this.setState({ sendingCode: false, sendingCodeError: true });
                    
                    this.setState({ error: true, errorText: strings('error') });
                }
                else
                {
                    this.setState({ sendingCode: false, emailVerified: true }, () =>
                    {
                        setTimeout(() =>
                        {
                            if (this.props.onEmailVerified != null)
                                this.props.onEmailVerified(response.data.status);
                        }, 3000);
                    });
                }
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    sendingCode: false,
                    sendingCodeError: true,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    
    validateNewEmail()
    {
        let allOk = true;
        
        var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        if (this.state.newEmail.trim().length == 0)
        {
            allOk = false;
        }
        else if (!emailRegex.test(this.state.newEmail.trim()))
        {
            allOk = false;
        }
        
        if (!allOk)
        {           
            return (
                <Error text={ strings('emailHasWrongFormat') } />
            )
        }
        
        this.setState({ newEmailError: !allOk });
        
        return allOk;
    }
    changeEmail()
    {
        this.setState({ changingEmail: true }, () =>
        {
            API.getInstance().createAccount(this.props.user.name, this.props.user.lastName, this.props.user.phoneNumber, this.state.newEmail, this.props.user.password)
            .then(response =>
            {
                if (this.props.onUserUpdated != null)
                    this.props.onUserUpdated(response.data);
                
                this.setState(
                {
                    changingEmail: false,
                    showDidntReceiveDialog: false,
                    showChangeEmailDialog: false
                },
                () =>
                {
                    this.sendEmail();
                    this.setState({ newEmail: '' });
                });
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    changingEmail: false,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
}